/* =========================================================
   Plantive Standards - JS (Optimized OOP)
========================================================= */
document.addEventListener('DOMContentLoaded', () => {

  const standardSections = document.querySelectorAll('.ps-container');

  standardSections.forEach(section => {
    
    // 1. Intersection Observer for Animations
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target); 
        }
      });
    }, { threshold: 0.15 }); 
    observer.observe(section);

    // 2. Swiper Initialization
    const swiperContainer = section.querySelector('.ps-swiper');
    if (!swiperContainer) return;

    // อ่านค่า Configuration จาก HTML data attributes
    const configSlides = parseFloat(section.dataset.slides) || 1.2;
    const isLoop = section.dataset.loop === 'true';

    function initStandardsSwiper() {
      if (typeof Swiper === 'undefined') {
        setTimeout(initStandardsSwiper, 100);
        return;
      }

      new Swiper(swiperContainer, {
        centeredSlides: true, 
        loop: isLoop, 
        speed: 800, 
        grabCursor: true,
        
        navigation: {
          nextEl: section.querySelector('.custom-next'),
          prevEl: section.querySelector('.custom-prev'),
        },
        
        pagination: {
          el: section.querySelector('.custom-swiper-pagination'),
          clickable: true,
        },

        breakpoints: {
          0: {
            slidesPerView: configSlides, 
            spaceBetween: 16,
            enabled: true
          },
          991: {
            enabled: false, 
            spaceBetween: 24
          }
        }
      });
    }

    initStandardsSwiper();
  });
});